import { track } from 'utils/koala-analytics';

export default () => next => action => {
  const { meta } = action.payload || {};
  if (meta && meta.analytics) {
    track(meta.analytics);
  }
  next(action);
};
